import React, { createContext, useContext } from 'react';

const MenuContext = createContext(null);

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenuContext must be used within a MenuProvider');
  }
  return context;
};

export const MenuProvider = ({ value, children }) => {
  return (
    <MenuContext.Provider value={value}>
      {children}
    </MenuContext.Provider>
  );
};
